export enum ShippingEstimatePolicy {
  SHIPPING_ESTIMATE_POLICY_UNKNOWN = 'SHIPPING_ESTIMATE_POLICY_UNKNOWN',
  /**
   * Only generates model-based estimates.
   */
  ESTIMATE_ONLY = 'ESTIMATE_ONLY',
  /**
   * Generates both model-based and fixed rate guaranteed estimates. Calculated guaranteed estimates are deferred.
   */
  GUARANTEED_PRELOAD = 'GUARANTEED_PRELOAD',
  /**
   * Generates both model-based and all guaranteed estimates.
   */
  GUARANTEED_FULL = 'GUARANTEED_FULL',
  /**
   * Generates only guaranteed estimates for Free Shipping Thresholds.
   */
  GUARANTEED_FREE_SHIPPING_ONLY = 'GUARANTEED_FREE_SHIPPING_ONLY',
  /**
   * Generates both model-based and EasyPost-based estimates. EasyPost-based estimates are deferred.
   */
  EASYPOST_PRELOAD = 'EASYPOST_PRELOAD',
  /**
   * Only generates EasyPost-based estimates.
   */
  EASYPOST_ESTIMATES_ONLY = 'EASYPOST_ESTIMATES_ONLY',
  /**
   * Generates both EasyPost-based and fixed rate guaranteed estimates. Calculated guaranteed estimates are deferred.
   */
  EASYPOST_GUARANTEED_PRELOAD = 'EASYPOST_GUARANTEED_PRELOAD',
  /**
   * Generates both EasyPost-based and all guaranteed estimates.
   */
  EASYPOST_GUARANTEED_FULL = 'EASYPOST_GUARANTEED_FULL',
}
